"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateFlagsContext = useUpdateFlagsContext;
const use_flags_context_hook_1 = require("./use-flags-context.hook");
function useUpdateFlagsContext() {
    const { updateFlagsContext } = (0, use_flags_context_hook_1.useFlagsContext)();
    return updateFlagsContext;
}
//# sourceMappingURL=use-update-flags-context.hook.js.map